import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { navigation } from '../nav-config';
import UserMenuMobile from './user/menu-mobile';

class Component extends BaseComponent {
    render() {
        return (
            <nav-bar-mobile>
                <ul>
                    {this.renderUserActions()}
                    {navigation.map(item => this.renderSection(item))}
                </ul>
            </nav-bar-mobile>
        );
    }

    renderUserActions = () => {
        if (this.props.logged_in) {
            return (
                <li class='mobile-nav-category'>
                    <UserMenuMobile />
                </li>
            );
        }

        return (
            <li class='mobile-nav-category'>
                <div class='login_signup_bar-side_menu'>
                    <div class='login_signup_bar'>
                        <a
                          class='login_signup_bar_login_link'
                          data-label='Log In'
                          href='/login'
                          onClick={this.track}
                        >
                            <i class='login_signup_bar_icon' />
                            <span class='login_signup_bar_login_text'>Log In</span>
                        </a>
                        <div class='or_text'>OR</div>
                        <div class='login_signup_bar_signup_button'>
                            <a
                              class='gen-button-signup'
                              data-label='Sign Up'
                              href='/signup'
                              onClick={this.track}
                            >
                                Sign up!
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        );
    }

    renderSection = (item) => {
        if (item) {
            let liClassName = 'mobile-nav-category';
            if (!item.submenu) {
                liClassName += ' nav-direct-link';
            }

            let h3ClassName = item.submenu ? 'category-header' : '';
            if (this.props.currentOpen == item.name) {
                h3ClassName += ' nav-accordion-expanded';
            }

            return (
                <li
                  class={liClassName}
                  onClick={(e) => this.toggle(e, item.name)}
                >
                    <h3
                      class={h3ClassName.trim()}
                    >
                        {this.renderItem(item)}
                    </h3>
                    {this.renderSubmenus(item)}
                </li>
            );
        }
        return null;
    }

    renderItem = (item) => {
        if (item.submenu) {
            return item.name;
        }

        const logged_in = this.props.logged_in && item.logged_in;

        return (
            <a
              href={logged_in ? item.logged_in.link : item.link}
              target={item.target ? item.target : ''}
            >{item.name}</a>
        );
    }

    renderSubmenus = (item) => {
        if (item.submenu) {
            let className = 'mobile-nav-submenu';
            if (this.props.currentOpen == item.name) {
                className += ' nav-accordion-expanded';
            }

            return (
                <div class={className}>
                    {item.submenu.map(subitem => this.renderSubmenu(item, subitem))}
                </div>
            );
        }

        return null;
    }

    renderSubmenu = (item, subitem) => {
        if (subitem) {
            return (
                <ul>
                    {subitem.links.map(dest => this.renderLink(item, subitem, dest))}
                </ul>
            );
        }

        return null;
    }

    renderLink = (item, subitem, dest) => {
        if (dest) {
            const logged_in = this.props.logged_in && dest.logged_in;
            const label = `${item.name} - ${logged_in ? dest.logged_in.name : dest.name}`;

            return (
                <li>
                    <a
                      href={logged_in ? dest.logged_in.link : dest.link}
                      target={item.target ? item.target : ''}
                      onClick={() => this.trackClick(label)}
                    >
                        {logged_in ? dest.logged_in.name : dest.name}
                    </a>
                </li>
            );
        }

        return null;
    }

    toggle = (e, label) => {
        if (e.target.localName == 'h3' && e.target.classList.contains('category-header')) {
            const action = this.props.currentOpen == label ? 'Close' : 'Open';

            let currentOpen = this.props.currentOpen == label ? null : label;

            this.props.updateOpen(currentOpen);
            this.props.trackPromo(['Navigation', label]);
            this.props.trackEvent(['Navigation', action, label]);
        }
    }

    trackClick = (label) => {
        const category = 'Navigation';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    currentOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].currentOpen,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
    updateOpen: payload => dispatch({ type: 'nav-bar-mobile:update', payload: {currentOpen: payload} }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/nav-bar-mobile.js